import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { OrganisationDto, OrganisationWrite } from '../models/organisation-dto';

@Injectable({ providedIn: 'root' })
export class OrganisationsService {
  constructor(private httpClient: HttpClient) {}

  get(): Observable<OrganisationDto[]> {
    return this.httpClient
      .get<OrganisationDto[]>(`${environment.backendUrl}/api/admin/v1/organisations`)
      .pipe(map((response) => response));
  }

  create(organisation: OrganisationWrite): Observable<any> {
    return this.httpClient.post(`${environment.backendUrl}/api/admin/v1/organisations`, organisation);
  }
}
